import { del, get, post } from "./api";
import type { ConnectorResponse } from "../types/crm";

export const getConnectors = (): Promise<ConnectorResponse[]> =>
  get("/api/crm/connectors");

export const disconnectConnector = (id: string): Promise<void> =>
  del(`/api/crm/connectors/${id}`);

export const getConnectUrl = (platform: string): Promise<{ url: string }> =>
  get(`/api/crm/connectors/${platform.toLowerCase()}/connect-url`);

export const connectWithApiKey = (
  platform: string,
  apiKey: string
): Promise<{ accountId: string | null }> =>
  post(`/api/crm/connectors/${platform.toLowerCase()}/connect-with-key`, { apiKey });

export interface TwitterCredentials {
  consumerKey: string;
  consumerSecret: string;
  accessToken: string;
  accessTokenSecret: string;
}

export const connectTwitterWithCredentials = (
  credentials: TwitterCredentials
): Promise<{ accountId: string | null }> =>
  post("/api/crm/connectors/twitter/connect-with-credentials", credentials);

export interface BlueBubblesConnectResponse {
  connectorId: string;
  status: string;
  computerId: string;
  serverVersion: string;
  connectedAt: string;
}

export const connectBlueBubbles = (
  serverUrl: string,
  password: string
): Promise<BlueBubblesConnectResponse> =>
  post("/api/crm/connectors/bluebubbles/connect", { serverUrl, password });

export const disconnectBlueBubbles = (): Promise<void> =>
  post("/api/crm/connectors/bluebubbles/disconnect", {});

export const getSlackWorkspaceInviteUrl = (): Promise<{ url: string }> =>
  get("/api/crm/connectors/slack/workspace-invite-url");

export interface StartSlackChannelRequest {
  initialMessage?: string;
  parentContactIds?: string[];
}

export interface StartSlackChannelResponse {
  channelId: string;
  channelUrl: string;
  messageSent: boolean;
  hasPendingInvites: boolean;
  skippedEmails: string[];
}

export const startSlackChannel = (
  prospectProfileId: string,
  request: StartSlackChannelRequest
): Promise<StartSlackChannelResponse> =>
  post(`/api/crm/prospects/${prospectProfileId}/slack-channel`, request);

export interface LinkSlackChannelResponse {
  channelId: string;
  channelName: string;
}

export const linkSlackChannel = (
  prospectProfileId: string,
  channelUrl: string
): Promise<LinkSlackChannelResponse> =>
  post(`/api/crm/prospects/${prospectProfileId}/slack/link-channel`, { channelUrl });

export const checkContactSlackWorkspaceStatus = (
  contactType: string,
  contactId: string
): Promise<{ isInWorkspace: boolean }> =>
  get(`/api/crm/contacts/${contactType}/${contactId}/slack/workspace-status`);
